module.exports = __webpack_public_path__ + "static/img/nav-min.9720905b.png";